import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.import}${COMMON_QUERY_PARAMS.CONSOLE_RULE_TYPE}/bulk`;

export const CONSOLE_BULK_ACTION = {
  DO_NOTHING: 'DoNothing',
  SET: 'Set',
  ADD_VALUE: 'AddValue',
  REMOVE_VALUE: 'RemoveValue',
  REMOVE_ALL: 'RemoveAll',
} as const;

export type BulkModifyAction =
  (typeof CONSOLE_BULK_ACTION)[keyof typeof CONSOLE_BULK_ACTION];

export interface BulkActionValue {
  action: BulkModifyAction;
  value?: unknown;
}

export interface BulkRuleValues {
  [key: string]: BulkActionValue[];
}

interface BulkActionRuleCommandArgs {
  sellerId: string;
  ruleType: string;
  ids: string[];
  values: BulkRuleValues;
}

async function bulkActionRuleCommand({
  sellerId,
  ruleType,
  ids,
  values,
}: BulkActionRuleCommandArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    const response = await apiCall<BackResponse<string>>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.CONSOLE_RULE_TYPE, ruleType),
      {
        method: SUPPORTED_METHODS.POST,
        json: { sellerId, ids, values },
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default bulkActionRuleCommand;
